import { WORKER_PROFILE_MODAL_MESSAGES } from 'constants/workerProfileMessages';
import { TabsTypes } from 'redux/Api/profileApi/type';

export const tabs: TabsTypes[] = [
  {
    idx: 1,
    key: 'status',
    name: 'Статус',
  },
  {
    idx: 2,
    key: 'contracts',
    name: 'Договоры',
  },
  {
    idx: 3,
    key: 'references',
    name: 'Справки',
  },
];

export const getErrorCreateContractMessage = (signedCount: number) =>
  signedCount > 1
    ? WORKER_PROFILE_MODAL_MESSAGES.ERROR_CREATE_CONTRACTS
    : WORKER_PROFILE_MODAL_MESSAGES.ERROR_CREATE_CONTRACT;
